<!--
* @Name：审批意见
* @Author: 刘玉
* @Date: 2021-12-17 11:13:27
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-17 11:13:27
-->
<template>
  <van-steps direction="vertical" :active="activeId" active-color="#1989fa">
    <van-step class="text-font-normal" v-for="(item, index) in opinionList" :key="`${item.nodeId}_${index}`">
      <p>
        <span>任务名称：</span>
        <span>{{ item.nodeName }}</span>
      </p>
      <p>
        <span>创建时间：</span>
        <span>{{ item.createTime }}</span>
      </p>
      <p>
        <span>审批时间：</span>
        <span>{{ item.completeTime }}</span>
      </p>
      <p>
        <span>执行人：</span>
        <span>{{ item.auditor }}</span>
      </p>
      <p>
        <span>任务标题：</span>
        <span>{{ item.a1FlowTaskTrajectoryEntity ? item.a1FlowTaskTrajectoryEntity.title : '' }}</span>
      </p>
      <p>
        <span>备注/意见：</span>
        <span>{{ item.a1FlowTaskTrajectoryEntity ? item.a1FlowTaskTrajectoryEntity.opinion : '' }}</span>
      </p>
      <p>
        <span>状态说明：</span>
        <span>{{ item.a1FlowTaskTrajectoryEntity ? item.a1FlowTaskTrajectoryEntity.statusVal : '' }}</span>
      </p>
    </van-step>
  </van-steps>
</template>

<script>
export default {
  name: 'ApprovalOpinions',
  props: {
    opinionList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    activeId() {
      const opinionListLength = this.opinionList.length
      if (opinionListLength === 0) return opinionListLength
      return opinionListLength - 1
    }
  }
}
</script>
